import script from "./PerformerProjectFormStep8.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep8.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep8.vue?vue&type=style&index=0&id=cd95eda4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd95eda4"]])

export default __exports__